import axios, { type AxiosResponse } from 'axios';

import Log from './Logger';
import { getAccessToken } from './auth';


const GRAPHQL_API_URL = import.meta.env.VITE_GRAPHQL_API_URL ?? '';

type GraphQLBody = any; // resp.config.data の型
type RespBody<T extends string, U> = { data: { [key in T]: U }, errors: any }
type Resp<T extends string, U> = AxiosResponse<RespBody<T, U>, GraphQLBody>

export function query<T>(method: 'allWebUIFeatureSetting', output: string[]): Promise<Resp<typeof method, T>>;

export async function query<T>(method: string, output: string[]): Promise<Resp<typeof method, T>> {
    const logger = Log.getLogger();

    logger.api.info('Cognito', 'Start to request: currentSession');
    const token = await getAccessToken();
    logger.api.info('Cognito', 'Succeed to request: currentSession');

    const apiResponse = await axios.post<RespBody<typeof method, T>>(
        GRAPHQL_API_URL,
        `{"query": "query { ${method} { ${output.join(', ')} }}" }`,
        {
            headers: {
                'Content-Type': 'application/graphql',
                'Authorization': `Bearer ${token}`,
            }
        }
    );

    return apiResponse;
}
